<template>

    <div class="element nested-element green" v-show="areaExpanded"
        v-bind:class="{ 'collapsed': !packageExpanded, 'expanded': packageExpanded, 'repo-dev': repo === 'dev' }">
        <div class="element-heading">
            <div class="collapse-icon" @click="toggleCollapse">
                <i class="fa fa-plus" v-show="!packageExpanded"></i>
                <i class="fa fa-minus" v-show="packageExpanded"></i>
            </div>
            <div class="element-name">

                <div class="display-name">{{ package_.display_name }}</div>
                <div class="output-identification-name">{{ package_.output_identification_name }}</div>

                <b-badge pill variant="primary" v-if="package_.content_per_machine" v-b-tooltip.hover
                    title="Ten pakiet posiada edytowalną zawartość dla każdej maszyny">
                    Zawartość per maszyna
                </b-badge>

                <b-badge pill variant="secondary" v-if="package_.autoenter" v-b-tooltip.hover
                    title="Pakiet ma włączony autoenter">
                    Autoenter
                </b-badge>

                <b-badge pill variant="danger" v-if="package_.has_game_not_on_list" v-b-tooltip.hover
                    title="Ten pakiet zawiera co najmniej jedną grę z brakiem plików źródłowych">
                    Brak źródeł
                </b-badge>

                <b-badge pill variant="warning" v-if="package_.has_not_approved_element" v-b-tooltip.hover
                    title="Ten pakiet zawiera co najmniej jedną grę wymagającą zatwierdzenia">
                    Gry do zatwierdzenia
                </b-badge>

                <b-badge pill variant="warning" v-if="package_.config_was_updated_since_last_approve" v-b-tooltip.hover
                    title="Konfiguracja została zaktualizowana od ostatniego zatwierdzenia">
                    Konfiguracja edytowana
                </b-badge>

                <b-badge pill variant="warning" v-if="package_.translations_were_updated_since_last_approve"
                    v-b-tooltip.hover title="Tłumaczenia zostały zaktualizowana od ostatniego zatwierdzenia">
                    Tłumaczenia edytowane
                </b-badge>

            </div>
            <div class="element-buttons">

                <div class="buttons-row" v-show="!orderManagementState">

                    <b-button size="xs" variant="success" v-if="package_.need_approve" @click="approvePackage()">
                        Zatwierdź
                    </b-button>

                    <b-button size="xs" variant="warning" v-if="repo === 'dev'" @click="clonePackage">
                        Powiel
                    </b-button>

                    <b-button size="xs" variant="warning" v-if="repo === 'dev'" @click="move">
                        Przenieś
                    </b-button>

                    <b-button size="xs" variant="primary" v-if="repo === 'dev'" @click="editPackage">
                        Edytuj
                    </b-button>

                    <b-button size="xs" variant="danger" @click="deletePackage">
                        Usuń
                    </b-button>

                </div>

                <div class="buttons-row" v-show="orderManagementState">

                    <a href="javascript:void(0);" class="text-primary up" v-show="repo === 'dev'" @click="moveUp"
                        title="W górę"><i class="fa fa-chevron-up"></i></a>
                    <span>&nbsp;</span>
                    <a href="javascript:void(0);" class="text-primary down" v-show="repo === 'dev'" @click="moveDown"
                        title="W dół"><i class="fa fa-chevron-down"></i></a>

                </div>

            </div>
        </div>
        <slot :package-expanded="packageExpanded" :package-created="packageCreated"></slot>
        <div class="element nested-element blue" v-bind:class="{ 'repo-dev': repo === 'dev' }" v-if="repo === 'dev'"
            v-show="packageExpanded">
            <div class="element-heading">
                <div class="element-text" v-bind:class="{ 'disabled': (repo !== 'dev' || orderManagementState) }">
                    <a href="javascript:void(0);" class="text-primary" @click="addSet">Dodaj zestaw</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {

    name: 'GameLibraryPackage',

    props: [
        'repo',
        'package_',
        'library',
        'areaExpanded',
        'orderManagementState',
        'expandAll',
        'libraryLoaded'

    ],

    data() {
        return {
            eventHub: window.eventHub,
            packageExpanded: false,
            state: false
        }
    },
    computed: {
        packageCreated: function () {
            if (this.expandAll) {
                this.packageExpanded = true
                this.state = true
            }
            if (this.libraryLoaded) {
                this.state = true
            }
            if (!this.state && this.packageExpanded) {
                this.state = true
            }
            return this.state
        }
    },

    mounted() {
        this.eventHub.$on('game-library-collapse-all', () => {
            this.packageExpanded = false;
        });

        this.eventHub.$on('game-library-expand-all', () => {
            this.packageExpanded = true;
        });
    },

    methods: {

        toggleCollapse() {
            if(this.state){
                this.packageExpanded = !this.packageExpanded
            }
            else{
                if (!this.libraryLoaded) {
                    this.eventHub.$emit('library-requested-while-not-loaded', this.package_.id)
                }
                this.state = true
                this.eventHub.$on('library-requested-loaded', () => {
                    this.packageExpanded = !this.packageExpanded
                })

            }
        },

        editPackage() {
            this.eventHub.$emit('game-library-edit-package', this.package_);
        },

        deletePackage() {
            this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć pakiet: ' + this.package_.display_name + '?' + (this.repo === 'prod' ? 'Jeśli pakiet zawiera materiały marketingowe, zostaną one również usunięte.' : ''), {
                title: 'Usuń pakiet',
                size: 'sm',
                okVariant: 'danger',
                okTitle: 'Usuń',
                cancelTitle: 'Anuluj',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.eventHub.$emit('processing-start');
                        axios.delete(route('game::game-library.delete-package', { repo: this.repo, id: this.package_.id }))
                            .then(response => {
                                this.eventHub.$emit('game-library-updated', response.data.data.library);
                                this.eventHub.$emit('processing-finish');
                                this.eventHub.$emit('toast-notification', response.data.message, 'success');
                            })
                            .catch(error => {
                                console.log(error);
                                this.eventHub.$emit('processing-finish');
                                this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                            });
                    }
                });
        },

        clonePackage() {
            this.$bvModal.msgBoxConfirm('Czy na pewno powielić pakiet: ' + this.package_.display_name + '?' + (this.repo === 'prod' ? 'Jeśli pakiet zawiera materiały marketingowe, zostaną one również usunięte.' : ''), {
                title: 'Powiel pakiet',
                size: 'sm',
                okVariant: 'info',
                okTitle: 'Powiel',
                cancelTitle: 'Anuluj',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.eventHub.$emit('processing-start');
                        axios.get(route('game::game-library.duplicate-package', { id: this.package_.id }))
                            .then(response => {
                                this.eventHub.$emit('game-library-updated', response.data.data.library);
                                this.eventHub.$emit('processing-finish');
                                this.eventHub.$emit('toast-notification', response.data.message, 'success');
                            })
                            .catch(error => {
                                console.log(error);
                                this.eventHub.$emit('processing-finish');
                                this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                            });
                    }
                });
        },

        approvePackage() {
            this.eventHub.$emit('game-library-approve-element', 'package', {
                id: this.package_.id,
                display_name: this.package_.display_name,
                updated_at: this.package_.updated_at ? (new Date(this.package_.updated_at)).toLocaleString() : '---',
                approved_at: this.package_.approved_at ? (new Date(this.package_.approved_at)).toLocaleString() : '---',
                files_updated_at: this.package_.files_updated_at ? (new Date(this.package_.files_updated_at)).toLocaleString() : '---',
                translations_updated_at: this.package_.translations_updated_at !== null ? (new Date(this.package_.translations_updated_at)).toLocaleString() : '---',
                files_were_updated_since_last_approve: this.package_.files_were_updated_since_last_approve,
                config_was_updated_since_last_approve: this.package_.config_was_updated_since_last_approve,
                translations_were_updated_since_last_approve: this.package_.translations_were_updated_since_last_approve,
            });
        },

        move() {
            this.eventHub.$emit('game-library-move-element', 'package', this.package_);
        },

        moveUp() {
            // Get index of element
            let areaIndex = this.library.findIndex(area => {
                return area.id === this.package_.area_id;
            });
            let packageIndex = this.library[areaIndex].packages.findIndex(package_ => {
                return package_.id === this.package_.id;
            });

            let previousPackage = this.library[areaIndex].packages[packageIndex - 1];

            // Check if there is element before
            if (previousPackage !== undefined) {

                let previousPackageNumberInOrder = previousPackage.number_in_order;
                let currentPackageNumberInOrder = this.package_.number_in_order;

                // Replace order number
                this.package_.number_in_order = previousPackageNumberInOrder;
                previousPackage.number_in_order = currentPackageNumberInOrder;

                // Update library variable
                this.library[areaIndex].packages[packageIndex] = previousPackage;
                this.library[areaIndex].packages[packageIndex - 1] = this.package_;
                this.eventHub.$emit('game-library-updated', this.library);
            }
        },

        moveDown() {
            // Get index of element
            let areaIndex = this.library.findIndex(area => {
                return area.id === this.package_.area_id;
            });
            let packageIndex = this.library[areaIndex].packages.findIndex(package_ => {
                return package_.id === this.package_.id;
            });

            let nextPackage = this.library[areaIndex].packages[packageIndex + 1];

            // Check if there is element after
            if (nextPackage !== undefined) {

                let nextPackageNumberInOrder = nextPackage.number_in_order;
                let currentPackageNumberInOrder = this.package_.number_in_order;

                // Replace order number
                this.package_.number_in_order = nextPackageNumberInOrder;
                nextPackage.number_in_order = currentPackageNumberInOrder;

                // Update library variable
                this.library[areaIndex].packages[packageIndex] = nextPackage;
                this.library[areaIndex].packages[packageIndex + 1] = this.package_;
                this.eventHub.$emit('game-library-updated', this.library);
            }
        },

        addSet() {
            this.eventHub.$emit('game-library-add-set', this.package_.id);
        },

    }

}
</script>

<style scoped></style>
